(function () {
    "use strict";

    // @ngInject
    function CouponsServiceCtor($injector, RepositoryService, Constants) {
        this.RepositoryService = RepositoryService;
        this.Constants = Constants;
        this.$injector = $injector;
        this.coupon = this.RepositoryService.storageGet(this.Constants.storage.COUPON);
    }

    Services.CouponsService = Class(() => {

        return {
            constructor: CouponsServiceCtor,

            getCoupon() {
                return this.coupon;
            },

            applyCoupon(coupon) {
                this.coupon = coupon;
                this.RepositoryService.storagePut(this.Constants.storage.COUPON, coupon);
            },

            reset() {
                this.coupon = null;
                this.RepositoryService.storageDelete(this.Constants.storage.COUPON);
            }
        };
    });
}());

